// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { AuditOutput } from 'thehive-sdk';
import listCards from '@Organisms/LiveStreamData/Cards';

interface LiveStreamCardProps {
    audit: AuditOutput;
}

export const LiveStreamCard = ({ audit }: LiveStreamCardProps): ReactElement | null => {
    const { base } = audit;
    const { objectType, object = {} } = base;

    const Card = listCards[objectType.toLowerCase()];
    return Card ? <Card data={object} base={base} /> : null;
};
